import { TextField } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoDetalle from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumentoDetalle';

interface ICampoCantidadSolicitadaProps {
    deshabilitado: boolean;
    manejarCambioCampo: (
        nombreCampo: keyof IDocumentoDetalle,
        nuevoValor: IDocumentoDetalle[keyof IDocumentoDetalle]
    ) => any;
    valor: number | undefined;
}

const CampoCantidadSolicitada: FunctionComponent<ICampoCantidadSolicitadaProps> = ({
    deshabilitado,
    manejarCambioCampo,
    valor,
}) => (
    <TextField
        disabled={deshabilitado}
        fullWidth
        label={<Texto id="DetallesFormulario.CampoCantidadSolicitada.Nombre" />}
        onChange={(event) => {
            if (/^\d*$/.test(event.target.value)) {
                manejarCambioCampo('CantidadSolicitada', event.target.value);
            }
        }}
        value={valor}
        required
    />
);

export default CampoCantidadSolicitada;
